import {Component, Input, Output, EventEmitter} from "@angular/core";

@Component({
  selector: 'app-st-usa-dropdown-list',
  templateUrl: './st-usa-dropdown-list.component.html',
  styleUrls: ['./st-usa-dropdown-list.component.scss'],
  standalone: false
})
export class StUsaDropdownListComponent {
  @Input()
  idVal: string = 'dropdownListId';

  @Input()
  label = 'Dropdown';

  @Input()
  defaultSelectFirst = false;

  @Input()
  menuList: any[] = [];

  @Input()
  inputVal?: string;

  selectedIndexVal = -1;

  @Input()
  placeHolderVal = 'Select';

  @Input()
  width?: string;

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000';

  @Output()
  onClick = new EventEmitter<Event>();

  public prepopulateChoice(): number {
    if (this.menuList.length > 0 && this.inputVal) {
      this.selectedIndexVal = 1 + this.menuList.findIndex(e => (e=== this.inputVal))
    }
    return this.selectedIndexVal;
  }

}
